import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux'
import { Action } from 'redux'
import { actions, selectors } from '@opallabs/wormhole'
import { State } from '@opallabs/wormhole/types'
import { DispatchProps, OwnProps, StateProps } from './types'
import { MomentPreviewModal } from '.'

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (
  state,
  ownProps
) => ({
  momentPreviewData: selectors.selectMomentPreviewData(
    state,
    ownProps.momentId
  ),
})

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch
) => ({
  getMomentData: (momentId): void => {
    dispatch(
      actions.getMoment({
        momentId,
        exposeUnscheduledMoments: true,
      })
    )
  },
  navigateTo: (params): Action => dispatch(actions.navigateTo(params)),
})

export const ConnectedMomentPreviewModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(MomentPreviewModal)
